import { render, staticRenderFns } from "./404.vue?vue&type=template&id=58dff818"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58dff818')) {
      api.createRecord('58dff818', component.options)
    } else {
      api.reload('58dff818', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=58dff818", function () {
      api.rerender('58dff818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/errors/404.vue"
export default component.exports